export default "__VITE_ASSET__v$b_ffgk__"